import { AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { TranslationService } from '@waseel-asp/tpa-waseel-lib-staging';
import { HelperService } from "../services/common/helper.service";

export function compareValidation(translate: TranslationService, controlName1: string, controlName2: string, msg1: string, msg2: string, helperService: HelperService): ValidatorFn {
  return (formGroup: FormGroup): { [key: string]: string } | null => {
    const control1Value = formGroup?.get(controlName1).value;
    const control2Value = formGroup?.get(controlName2).value;

    if (control2Value && control1Value && control1Value < control2Value) {
      formGroup.get(controlName1)?.setErrors({ policyQuotationValidation: translate.instant('FORM_FIELD.FORM_MAX_VALUE', { msg1: msg1, msg2: msg2 }) });
      formGroup.get(controlName2)?.setErrors({ policyPremiumValidation: translate.instant('FORM_FIELD.FORM_MIN_VALUE', { msg1: msg1, msg2: msg2 }) });
      helperService.manualChangeTriggered();
      return null;
    } else {
      if (formGroup.get(controlName1)?.hasError('policyQuotationValidation')) {
        formGroup.get(controlName1).setErrors(null);
        formGroup.get(controlName1)?.updateValueAndValidity({ onlySelf: true, emitEvent: false });
      }
      if (formGroup.get(controlName2)?.hasError('policyPremiumValidation')) {
        formGroup.get(controlName2).setErrors(null);
        formGroup.get(controlName2)?.updateValueAndValidity({ onlySelf: true, emitEvent: false });
      }
      helperService.manualChangeTriggered();
      return null;
    }
  };
}

export function matchControls(translate: TranslationService, controlName1: string, controlName2: string, value: string): ValidatorFn {
  return (formGroup: FormGroup): { [key: string]: string } | null => {
    const control1Value = formGroup.get(controlName1)?.value;
    const control2Value = formGroup.get(controlName2)?.value;

    if (control1Value && control2Value && control1Value !== control2Value)
      formGroup.get(controlName2)?.setErrors({ mismatch: translate.instant('COMMON.VALUES_NOT_MATCH', { Value: translate.instant(value) }) });
    else {
      if (formGroup.get(controlName2)?.hasError('mismatch')) {
        formGroup.get(controlName2)?.setErrors(null);
        formGroup.get(controlName2)?.updateValueAndValidity({ onlySelf: true, emitEvent: false });
      }
    }
    return null;
  };
}

// export function maxLengthForControl(maxLength: number, errorMessage: string): ValidatorFn {
//   return (control: AbstractControl): ValidationErrors | null => {
//     if (!control.parent)
//       return null;
//     const controlName = Object.keys(control.parent.controls).find(
//       (name) => control === control.parent?.get(name)
//     );
//     const value = control.value;
//     if (value !== null && value !== undefined && value.toString().length > maxLength)
//       return { [controlName]: errorMessage };
//     else
//       return null;
//   };
// }

export function minimumLengthArrayValidator(minLength: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control instanceof FormArray)
      return control.length >= minLength ? null : { 'minLength': { requiredLength: minLength, actualLength: control.length } };
    return null;
  };
}

// export function minLengthForControl(minLength: number, errorMessage: string): ValidatorFn {
//   return (control: AbstractControl): ValidationErrors | null => {
//     if (!control.parent)
//       return null;
//     const controlName = Object.keys(control.parent.controls).find(
//       (name) => control === control.parent?.get(name)
//     );
//     const value = control.value;
//     if (value !== null && value !== undefined && value.toString().length < minLength)
//       return { [controlName]: errorMessage };
//     else
//       return null;
//   };
// }


export function multipleOfValidator(translate: TranslationService, multiple: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value && value % multiple !== 0)
      return { 'notMultiple': translate.instant(`PREAUTH.PREAUTH_REQUEST.BASIC_INFO.VISION_MULTIPLY`, { multiple: multiple }) };
    return null;
  };
}

export function toothPickerValidator(
  validNumbers: number[],
  errorMessage: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    // Check if the value is null or not in the list of valid numbers
    if (value !== null && value !== undefined && !validNumbers.includes(+value))
      return { invalidNumber: errorMessage }; // Return error object
    return null; // Validation passes
  };
}

export function dateDifferenceValidator(birthDate: Date, errorMessage: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const serviceEndDate = control.value;

    if (!birthDate || !serviceEndDate)
      return null;

    const startDate = new Date(birthDate);
    const endDate = new Date(serviceEndDate);

    const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays > 90)
      return { invalidDate: errorMessage };

    return null;
  };
}

export function onlyZeroesNotAllowed(errorMessage: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.parent) return null;

    const controlName = Object.keys(control.parent.controls).find(
      (name) => control === control.parent?.get(name)
    );
    const value = control.value;
    if (value !== null && value !== undefined && /^[0]+$/.test(value.toString().trim()))
      return { [controlName]: errorMessage };
    return null;
  };
}